import * as React from 'react';
import { useState } from 'react';
import './edit.scss';
import { Radio } from 'antd';
import { useParams } from 'react-router-dom';

import { Page } from '../../../../../components/page/page';
import { EditUserForm } from './sections/form';
import { EditUserBalance } from './sections/balance';
import { Card } from 'components/card/card';
import { ActivitiesPanel } from '../../marketing/activities/activities-panel';

export const EditUser: React.FC = () => {
    const [stages, setStages] = useState<'form' | 'balance' | 'activities'>('form');
    const userId = useParams().id ?? '';

    return (
        <Page title="تغییر اطلاعات کاربر" className="pmx-dashboard-users-edit">
            <div className="button-group-container">
                <Radio.Group size="large" value={stages} onChange={(e) => setStages(e.target.value)}>
                    <Radio.Button value="form">ویرایش</Radio.Button>
                    <Radio.Button value="balance">موجودی</Radio.Button>
                    <Radio.Button value="activities">اکتیویتی‌ها</Radio.Button>
                </Radio.Group>
            </div>
            {stages === 'form' && <EditUserForm />}
            {stages === 'balance' && <EditUserBalance />}
            {stages === 'activities' && (
                <Card className="pmx-marketing">
                    <ActivitiesPanel userId={userId} hint="تماس‌ها، پیامک‌ها و اقدامات مارکتینگ این کاربر." />
                </Card>
            )}
        </Page>
    );
};
